import styled from "@emotion/styled";
import {
  type CommunicationHistory,
  type Opportunity,
  useCommunicationHistory,
} from "@repo/api";
import { Loading, Text, Variables } from "@repo/skapa";
import { t } from "@repo/translation";
import { ModalSheet, SectionContainer } from "@repo/ui";

import { CommunicationHistoryItemCard } from "./CommunicationHistoryItemCard";

const HistoryList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Variables.space100};
`;

interface CommunicationHistoryModalProps {
  isOpen: boolean;
  opportunity: Opportunity;
  onClose: () => void;
  onBack?: () => void;
}

export const CommunicationHistoryModal = ({
  isOpen,
  opportunity,
  onClose,
  onBack,
}: CommunicationHistoryModalProps) => {
  const { data, isLoading } = useCommunicationHistory(opportunity.id);

  return (
    <ModalSheet
      title={t("label.communication_history")}
      visible={isOpen}
      onClose={onClose}
      onBack={onBack}
      size="large"
    >
      <SectionContainer>
        {isLoading && <Loading />}

        {!isLoading && data?.length === 0 && (
          <Text>{t("prompt.no_communication_history")}</Text>
        )}

        {!isLoading && data && (
          <HistoryList>
            {data.map((item: CommunicationHistory) => (
              <CommunicationHistoryItemCard key={item.id} item={item} />
            ))}
          </HistoryList>
        )}
      </SectionContainer>
    </ModalSheet>
  );
};
